import React, { Component } from 'react';
import radium, { Style } from 'radium';
import autobind from 'autobind-decorator';
import { ActivityIndicator, Icon } from '@lyearn-team/frontend-components';
import { parse } from 'iso8601-duration';

import UpdateSCORMMutation from '../../mutations/UpdateSCORMMutation';

class SCORMCard extends Component {
  static styles = {};
  state = {
    launchContent: false,
    showLoader: false
  };

  UNSAFE_componentWillMount() {
    this.launchOnInit = !this.props.card.newWindow;
    if (this.launchOnInit) {
      this.state.showLoader = true;
    }
  }

  componentDidMount() {
    if (this.launchOnInit) {
      this.launchOnInitTimeout = window.setTimeout(
        () => this.launchScormContent(this.props)(),
        2500
      );
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.card.pid !== this.props.card.pid) {
      this.launchOnInitTimeout && window.clearTimeout(this.launchOnInitTimeout);
      this.launchOnInitTimeout = null;
      this.state.showLoader = false;

      /* if (this.scormContentWindow) {
        this.scormContentWindow.close();
        this.scormContentWindow = null;
      } */
      this.state.launchContent = false;

      if (this.launchOnInit) {
        this.cardUnloaded(this.props.isEnrolled);
      }

      this.launchOnInit = !nextProps.card.newWindow;
      if (this.launchOnInit) {
        this.state.showLoader = true;
        this.launchOnInitTimeout = window.setTimeout(
          () => this.launchScormContent(nextProps)(),
          2500
        );
      }
    }
  }

  componentWillUnmount() {
    /* if (this.scormContentWindow) {
      this.scormContentWindow.close();
      this.scormContentWindow = null;
    } */
    this.props.toggleFullscreen(false);
    if (this.launchOnInit) {
      this.cardUnloaded(this.props.isEnrolled);
    }
  }

  setLocalURL(url) {
    return window.location.origin + '/lyearn/scorm/' + url.split('/scorm/')[1];
  }

  getDefinedScormVariable(firstVar, secondVar) {
    let scormVar = null;
    if (typeof firstVar !== 'undefined') {
      scormVar = firstVar;
    }

    if (typeof secondVar !== 'undefined') {
      scormVar = secondVar;
    }
    return scormVar;
  }

  scormContentWindow = null;

  calculateSessionTime(scormObj) {
    const sessionTime = this.getDefinedScormVariable(
      scormObj['cmi.core.session_time'],
      scormObj['cmi.session_time']
    );
    let sessionSeconds = 0;
    if (sessionTime && sessionTime.indexOf('P') > -1) {
      sessionSeconds = parse(sessionTime).seconds;
      const totalHours = parseInt(sessionSeconds / 3600);
      sessionSeconds -= totalHours * 3600;
      const totalMinutes = parseInt(sessionSeconds / 60);
      sessionSeconds -= totalMinutes * 60;
      return totalHours + ':' + totalMinutes + ':' + sessionSeconds;
    }
    return sessionTime;
  }

  @autobind
  submitSCORMData(scormObj, callFromFinish) {
    if (this.props.preview || this.props.guestMode) {
      return;
    }
    if (
      scormObj['cmi.core.lesson_mode'] === 'browse' ||
      scormObj['cmi.core.credit'] === 'no-credit' ||
      scormObj['cmi.mode'] === 'browse' ||
      scormObj['cmi.credit'] === 'no-credit'
    )
      return;
    let reAttemptCountInt =
      this.props.card.performance && this.props.card.performance.reAttemptCount;
    let lessonStatus = '';
    lessonStatus = this.getDefinedScormVariable(
      scormObj['cmi.core.lesson_status'],
      scormObj['cmi.completion_status']
    );
    if (scormObj.scormVersion === '2004') {
      lessonStatus = this.getDefinedScormVariable(
        scormObj['cmi.success_status'],
        scormObj['cmi.completion_status']
      );
    }
    if ((lessonStatus === 'passed' || lessonStatus === 'failed') && callFromFinish) {
      reAttemptCountInt += 1;
      // console.log('re attempt count', reAttemptCountInt);
    }
    let optimisticSuccessStatus = '';
    if (lessonStatus === 'passed' && this.props.card.isGradable) {
      optimisticSuccessStatus = 'PASS';
    } else if (lessonStatus === 'failed' && this.props.card.isGradable) {
      optimisticSuccessStatus = 'FAIL';
    } else {
      optimisticSuccessStatus = 'NA';
    }
    const mutation = new UpdateSCORMMutation(
      {
        courseId: this.props.course.pid,
        cardId: scormObj.cardPid,
        userId: this.getDefinedScormVariable(
          scormObj['cmi.core.student_id'],
          scormObj['cmi.learner_id']
        ),
        lesson_location: this.getDefinedScormVariable(
          scormObj['cmi.core.lesson_location'],
          scormObj['cmi.location']
        ),
        credit: this.getDefinedScormVariable(scormObj['cmi.core.credit'], scormObj['cmi.credit']),
        entry: this.getDefinedScormVariable(scormObj['cmi.core.entry'], scormObj['cmi.entry']),
        lesson_status: lessonStatus,
        score_raw: this.getDefinedScormVariable(
          scormObj['cmi.score.raw'],
          scormObj['cmi.core.score.raw']
        ),
        total_time: this.getDefinedScormVariable(
          scormObj['cmi.core.total_time'],
          scormObj['cmi.total_time']
        ),
        suspend_data: scormObj['cmi.suspend_data'],
        exit: this.getDefinedScormVariable(scormObj['cmi.core.exit'], scormObj['cmi.exit']),
        session_time: this.calculateSessionTime(scormObj),
        interactions: JSON.stringify(scormObj['cmi.interactions']),
        progress_measure: this.getDefinedScormVariable(scormObj['cmi.progress_measure']),
        reAttemptCount: reAttemptCountInt,
        cardMainId: scormObj.cardId,
        courseMainId: this.props.course.id,
        cardObj: this.props.card,
        successStatus: optimisticSuccessStatus,
        completionStatus:
          lessonStatus === 'completed' || lessonStatus === 'passed' || lessonStatus === 'failed'
            ? 'COMPLETE'
            : 'IN_COMPLETE',
        pathId: this.props.pathInfo && this.props.pathInfo.pid,
        pathGraphId: this.props.pathInfo && this.props.pathInfo.id,
        coursePerformanceId:
          this.props.course &&
          this.props.course.coursePerformance &&
          this.props.course.coursePerformance.id,
        userGraphId: this.props.userObj.id
      },
      {
        onSuccess: s => {
          console.debug(s);
        },
        onFailure: t => {
          const error = t.getError() || new Error('Mutation failed.');
          console.error(error);
        }
      }
    );
    mutation.commit();
  }

  @autobind
  cardUnloaded(isEnrolled) {
    let rootQ = {};
    if (isEnrolled) {
      rootQ = this.props.rootQ;
      rootQ.cardPerformanceId = this.props.card.performance.id;
      rootQ.cardPerformanceComplete = this.props.card.performance.completionStatus === 'COMPLETE';
    } else {
      rootQ.mastery_score = '';
      rootQ.score_raw = '0';
      rootQ.scormData = '{}';
    }
    rootQ.cardId = this.props.card.id;
    rootQ.cardPid = this.props.card.pid;
    window.SCORM.setLMSValues(rootQ, this.submitSCORMData, false, isEnrolled);
  }

  launchScormContent = props => e => {
    let rootQ = {};
    if (props.isEnrolled) {
      rootQ = props.rootQ;
      rootQ.cardPerformanceId = props.card.performance.id;
      rootQ.cardPerformanceComplete = props.card.performance.completionStatus === 'COMPLETE';
    } else {
      rootQ.mastery_score = '';
      rootQ.score_raw = '0';
      rootQ.scormData = '{}';
    }
    rootQ.cardId = props.card.id;
    rootQ.cardPid = props.card.pid;
    window.SCORM.setLMSValues(rootQ, this.submitSCORMData, true, props.isEnrolled);

    if (props.card.newWindow) {
      const windowWidth = 1024;
      const windowHeight = 700;
      const left = window.screen.width / 2 - (windowWidth / 2 + 10);
      const top = window.screen.height / 2 - (windowHeight / 2 + 50);
      this.props.toggleFullscreen(true);
      this.setState({
        showLoader: false,
        launchContent: true
      });
      // this.scormContentWindow = window.open(this.setLocalURL(props.card.resource.content.url), 'scorm', 'toolbar=0,status=0,width=' + windowWidth + ',height=' + windowHeight + ',left=' + left + ',top=' + top);
    } else {
      // props.toggleFullscreen(true);
      this.setState({
        // showLoader: false,
        launchContent: true
      });
    }
  };

  hideScormContent = () => {
    this.cardUnloaded(this.props.isEnrolled);
    // this.props.toggleFullscreen(false);
    this.setState({ launchContent: false });
    this.props.toggleFullscreen(false);
  };

  iframeLoaded = () => {
    console.log('loaded from IFRAME');
    this.setState({
      showLoader: false
    });
    /* if (this.refs.iframe) {
      $j(this.refs.iframe).contents().find('head').append(windowLoadedStyle);
      $j(this.refs.iframe).contents().find('body').append(windowLoadedScript);
    } */
  };

  renderNoQuestionView = (text, styles) => <div style={styles.noQuestion}>Empty assignment</div>;

  render() {
    const url = this.setLocalURL(this.props.card.resource.content.url);
    const styles = SCORMCard.styles;
    const type = this.props.card.type;
    const scormUrl = this.props.card.resource.content.url;
    if (type === 'learningCard' && !scormUrl) {
      return this.renderNoQuestionView('lesson', styles);
    }
    if (type === 'assignmentCard' && !scormUrl) {
      return this.renderNoQuestionView('assignment', styles);
    }
    return (
      <div style={this.launchOnInit ? styles.fullWidth : styles.buttonWrapper}>
        {!this.launchOnInit && (
          <span
            onClick={this.launchScormContent(this.props)}
            style={[styles.launchContentButton, styles.displayFlexRow, styles.alignItemsCenter]}
          >
            Launch Content
          </span>
        )}
        {this.state.showLoader && (
          <div className="mediumActivityLoaderWrapper">
            <ActivityIndicator />
          </div>
        )}
        {this.state.launchContent ? (
          this.launchOnInit ? (
            <div style={styles.inlineInnerWrapper} onClick={e => e.stopPropagation()}>
              <iframe
                ref="iframe"
                id="iframe0"
                ref="iframe"
                style={styles.inlineIframe}
                src={url}
                onLoad={this.iframeLoaded}
              >
                Iframe is not supported
              </iframe>
            </div>
          ) : (
            <div style={styles.popUpMainWrapperStyle}>
              <div
                className="closeButtonWrapper"
                style={[styles.closeButtonWrapper, styles.displayFlexRow, styles.alignItemsCenter]}
                onClick={this.hideScormContent}
                role="presentation"
              >
                {/* <span
                  className="closeButton"
                  key="closeButton"
                  style={styles.closeButton}
                  onClick={this.hideScormContent}
                /> */}
                close <Icon type="close" style={styles.closeIcon} />
              </div>
              <div style={styles.popUpInnerWrapper} onClick={e => e.stopPropagation()}>
                <div style={styles.container}>
                  <iframe
                    ref="iframe"
                    id="iframe0"
                    ref="iframe"
                    style={styles.iframe}
                    src={url}
                    onLoad={this.iframeLoaded}
                  >
                    Iframe is not supported
                  </iframe>
                </div>
              </div>
            </div>
          )
        ) : null}
        <Style rules={styles.classBased} />
      </div>
    );
  }
}

SCORMCard.styles = {
  classBased: {
    '.closeButtonWrapper .closeButton': {
      width: '20px',
      height: '20px',
      display: 'inline-block',
      position: 'relative',
      overflow: 'hidden',
      cursor: 'pointer'
    },
    '.closeButtonWrapper .closeButton:after': {
      content: '""',
      position: 'absolute',
      height: '2px',
      width: '100%',
      top: '50%',
      left: '0px',
      marginTop: '-1px',
      background: 'rgb(223, 229, 234)',
      transform: 'rotate(45deg)'
    },
    '.closeButtonWrapper .closeButton:before': {
      content: '""',
      position: 'absolute',
      height: '2px',
      width: '100%',
      top: '50%',
      left: '0px',
      marginTop: '-1px',
      background: 'rgb(223, 229, 234)',
      transform: 'rotate(-45deg)'
    },
    '.closeButtonWrapper .closeButton:hover:before,.closeButtonWrapper .closeButton:hover:after': {
      background: 'white'
    }
  },
  noQuestion: {
    fontSize: '32px',
    textAlign: 'center'
  },
  container: {
    position: 'relative',
    height: '100%',
    width: '100%',
    overflow: 'auto'
  },
  displayFlexRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  alignItemsCenter: {
    alignItems: 'center'
  },
  containerFullScreen: {
    position: 'fixed',
    top: '0px',
    left: '0px',
    right: '0px',
    bottom: '0px',
    height: '100%',
    width: '100%',
    zIndex: '1000',
    justifyContent: 'center',
    padding: '0px 40px 0px',
    boxSizing: 'border-box'
    // backgroundColor: '#fff',
  },
  iframe: {
    width: '100%',
    height: '100%',
    minHeight: '300px',
    border: 'none',
    display: 'block'
  },
  inlineIframe: {
    position: 'absolute',
    top: '0px',
    left: '0px',
    height: '100%',
    width: '100%'
  },
  fullScreenBtn: {
    height: '25px',
    width: '25px',
    backgroundColor: '#fff',
    position: 'absolute',
    bottom: '5px',
    right: '5px',
    cursor: 'pointer',
    zIndex: 2
  },
  iframeLoader: {
    position: 'absolute',
    top: '150px',
    left: '50%',
    transform: 'translateX(-50%)'
  },
  popUpInnerWrapper: {
    width: '100%',
    height: '100%',
    boxShadow: 'none',
    position: 'relative',
    boxSizing: 'border-box',
    background: 'transparent',
    // border: 'none',
    padding: '0px',
    margin: '0px auto'
  },
  inlineInnerWrapper: {
    width: '100%',
    height: '100%',
    boxShadow: 'none',
    // position: 'relative',
    boxSizing: 'border-box',
    background: 'transparent',
    // border: '10px solid #dfe5ea',
    border: 'none',
    padding: '0px 10px',
    margin: '0px auto',
    position: 'relative',
    minHeight: 'calc(100vh - 159px)'
  },
  popUpMainWrapperStyle: {
    cursor: 'default',
    padding: '20px 0px 0px',
    boxSizing: 'border-box',
    background: 'rgba(0,0,0,0.8)',
    position: 'fixed',
    left: '0',
    width: '100%',
    height: '100%',
    top: '0',
    bottom: '0',
    zIndex: '1001',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column'
  },
  popUpActions: {
    position: 'absolute',
    right: '20px',
    bottom: '20px'
  },
  confirmationText: {
    fontSize: '15px',
    lineHeight: '20px',
    fontWeight: '500'
  },
  launchContentButton: {
    textTransform: 'uppercase',
    fontSize: '13px',
    lineHeight: '18px',
    background: '#00AAD9',
    color: 'white',
    justifyContent: 'center',
    padding: '5px 30px',
    borderRadius: '4px',
    cursor: 'pointer',
    height: '30px',
    letterSpacing: '0.6px',
    fontFamily: 'ProximaNova',
    ':hover': {
      boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.2)'
    }
  },
  closeButtonWrapper: {
    justifyContent: 'center',
    cursor: 'pointer',
    position: 'absolute',
    top: '0px',
    right: '10px',
    color: '#fff',
    fontWeight: '500'
  },
  fullWidth: {
    width: '100%'
  },
  closeButton: {
    // fontSize: '15px',
    // lineHeight: '21px',
    // borderRadius: '4px',
    // textTransform: 'uppercase',
    // letterSpacing: '0.5px',
    // justifyContent: 'center',
    // fontWeight: '600',
    // width: '150px',
    // height: '40px',
    // marginTop: '20px',
    // display: 'flex',
    // alignItems: 'center',
  },
  closeIcon: {
    marginLeft: '4px',
    fill: 'white'
  }
};

export default radium(SCORMCard);
